import { axios } from '@/services/axios';

export const createCountry = (countryData) => {
    return axios.post('/country', countryData);
};
